import { path, uniq } from 'ramda'
import { userHasRole } from 'app/core/utils/rbac'
import store from 'app/store'

export const humanReadableSize = (bytes, addUnit = true) => {
  if (bytes === 0) {
    return '0.00 B'
  }
  if (!bytes) {
    return 'N/A'
  }

  const e = Math.floor(Math.log(bytes) / Math.log(1024))
  const size = (bytes / Math.pow(1024, e)).toFixed(2)
  if (!addUnit) {
    return size
  }
  return size + ' ' + ' KMGTP'.charAt(e) + 'iB'
}

export const getCurrentUser = () => {
  const session = store.getState().session
  return session.userDetails
}

export const getHideCondForDeleteOnTermination = (selected) => {
  if (
    !selected ||
    selected?.length === 0 ||
    selected[0]?.['os-extended-volumes:volumes_attached']?.length === 0
  ) {
    return true
  }
  return false
}

/**
 * Checks if all keys in the source (object or Map) exist in the target object
 * and that their corresponding values match.
 *
 * @param source - Object or Map containing keys and values to match
 * @param target - Object to compare against
 * @returns true if all keys in source exist in target with the same values, false otherwise
 */
export const doAllKeysAndValuesMatch = (
  source: Record<string, any> | Map<string, any>,
  target: Record<string, any>,
): boolean => {
  if (!source) return false

  // Get all keys from source
  const keys = source instanceof Map ? Array.from(source.keys()) : Object.keys(source)

  // Return false if there are no keys to compare
  if (keys.length === 0) return false

  // Check that every key in source exists in target with the same value
  return keys.every((key) => {
    const sourceValue = source instanceof Map ? source.get(key) : source[key]
    return target?.[key] === sourceValue
  })
}

export const getLastRefreshTime = (cacheKey) => {
  const state = store.getState()
  return state?.cache?.lastRefreshTime?.[cacheKey]
}

export const bypassKey = 'bypass'

export const hasPermissions = (permissionsPath: string[]): boolean => {
  // Skip for original keystone roles
  if (userHasRole(['admin', 'member', 'reader'])) {
    return true
  }
  const state = store.getState()
  const permissions = state.permissions || {}
  if (permissionsPath[0] === bypassKey) {
    return true
  }
  return !!path(permissionsPath, permissions)
}

export const convertDetailsPageDropdowns = (dropdownActionGroups) => {
  return dropdownActionGroups.map((group) => {
    return {
      ...group,
      actions: group.actions.map((action) => {
        return {
          ...action,
          disabled: action.permissionsPath
            ? !hasPermissions(action.permissionsPath) || action.disabled
            : action.disabled,
          tooltip:
            action.permissionsPath && !hasPermissions(action.permissionsPath)
              ? 'You do not have permissions for that action'
              : action.tooltip,
        }
      }),
    }
  })
}
